module.exports = __webpack_public_path__ + "img/12_en.007896af.png";